export default class DateHelper {
    public static parseToFormattedLocalDate = (dateString: string) => {
        if (!dateString || dateString.match(/^\s*$/)) {
            return null;
        }
        const dateToProcess = new Date(dateString);
        const date = DateHelper.addZeroToOneDigitNumber(dateToProcess.getDate());
        const month = DateHelper.addZeroToOneDigitNumber(dateToProcess.getMonth() + 1);
        const year = dateToProcess.getFullYear();
        const hours = dateToProcess.getHours();
        const minutes = DateHelper.addZeroToOneDigitNumber(dateToProcess.getMinutes());
        return `${date}.${month}.${year} ${hours}:${minutes}`;
    }

    private static addZeroToOneDigitNumber = (dateTimeNumber: number) => {
        const numberAsString = dateTimeNumber.toString();
        return numberAsString.match(/^\d{1}$/) ? `0${numberAsString}` : numberAsString;
    }
}
